import React, { FunctionComponent } from "react";
import "./style.scss";

const PrivacyPolicyPage: FunctionComponent = () => {
    return <div className="PrivacyPolicyPage">
        <div className="content">
            <h1>Privacy Policy</h1>
            <div className="date">Effective Date: December 30, 2022</div>
            <div className="blocks">
                <div className="block">
                    <h3>Definitions</h3>
                    <div className="text">
                        <b>Employer</b> - Timinator’s tenant<br/>
                        <b>Employee</b> - Timininator tenant’s employee<br/>
                        <b>Client</b> - Timininator tenant’s client<br/>
                        <b>User</b> - Any Timininator’s tenant’s employee, added as a user of the service for the tenant<br/>
                        <b>Application</b> - Bot application for time tracking called Timinator<br/>
                        <b>Service</b> - Electronic time tracking service offered by Spark Agency FZE to its users.<br/>
                        <br/>
                        In this privacy policy, the terms 'We,' 'Our,' 'Ours,' and 'Us,' refer collectively to Spark Agency
                        FZE, and the terms 'You' and 'Your' refer to you, the person accepting these terms and
                        conditions. The terms 'Party' and 'Parties' refer to both Spark Agency FZE and yourself, or either
                        Spark Agency FZE or yourself, as the context requires.
                    </div>
                </div>

                <div className="block">
                    <h3>General</h3>
                    <div className="text">
                        We respect your privacy and are committed to protecting your personal information when you
                        use our time-tracking bot application and related services. This privacy policy explains how we
                        collect, use, and share personal information about you when you use the service.
                        We may collect personal information about you when you provide it to us directly, such as when
                        you create an account, input information into our service, or contact us for support. We may also
                        collect personal information automatically as you use the service, including through the use of
                        cookies, web beacons, and other tracking technologies. This personal information may include
                        your name, email address, phone number, IP address, location data, and other information
                        related to your use of the service.
                        We may share your personal information with third parties in certain circumstances, such as to
                        comply with legal requirements, to protect the rights and safety of ourselves and others, or to
                        provide the service to you. We may also share personal information with third-party service
                        providers who assist us in providing the service, such as hosting and maintenance providers,
                        analytics providers, and payment processors.
                    </div>
                </div>

                <div className="block">
                    <h3>The data controller</h3>
                    <div className="text">
                        Spark Agency FZE<br/>
                        License No: 18231/2022<br/>
                        Address: Creative Tower, P.O.BOX 4422, Fujairah, Emirate of Fujairah<br/>
                    </div>
                </div>

                <div className="block">
                    <h3>Data protection officer of Spark Agency FZE</h3>
                    <div className="text">
                        Artem Oshchepkov<br/>
                        artem.oshchepkov@spark.run<br/>
                    </div>
                </div>

                <div className="block">
                    <h3>The name of the data registry</h3>
                    <div className="text">
                        The user database of the Timinator service.
                    </div>
                </div>

                <div className="block">
                    <h3>GDPR Sub Processors</h3>
                    <h4>Stripe</h4>
                    <div className="text">
                        Collaboration: Processing payments from Employers<br/>
                        Company location: EU-US<br/>
                        Data processing: EU-US<br/>
                        <ul>
                            <li>We store employers' e-mails — required from the payment processor to send receipts on performed payments</li>
                            <li>We send employers' e-mails to Stripe.</li>
                        </ul>
                    </div>

                    <h4>Azure</h4>
                    <div className="text">
                        Collaboration: Cloud service provider (operations and storage)<br/>
                        Company location: EU-US<br/>
                        Data processing: EU-US<br/>
                        Data storage location: EU<br/>
                        Data:<br/>
                        <ul>
                            <li>Employees:</li>
                                <ul className="second">
                                    <li>Email</li>
                                    <li>Full name</li>
                                    <li>Phone number</li>
                                    <li>Position</li>
                                    <li>Shifts</li>
                                </ul>
                            <li>Clients:</li>
                                <ul className="second">
                                    <li>Name</li>
                                    <li>Contact person name</li>
                                    <li>Contact email</li>
                                    <li>Project names.</li>
                                </ul>
                        </ul>
                    </div>

                    <div className="block">
                        <h3>Zoho Invoices</h3>
                        <div className="text">
                            Collaboration: ERP<br/>
                            Company location: India<br/>
                            Data processing: EU-US<br/>
                            Only if the workspace admin has enabled Zoho-integration<br/>
                            <ul>
                                <li>We send employees’ full names and emails</li>
                                <li>We send employees’ shifts</li>
                                <li>We send clients' names and contact persons</li>
                                <li>We send clients’ project names.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="block">
                        <h3>Slack</h3>
                        <div className="text">
                            Collaboration: Communication<br/>
                            Company location: EU-US<br/>
                            Data processing: EU-US<br/>
                            Only sent in the tenant’s workspace:<br/>
                            <ul>
                                <li>Employee:</li>
                                <ul className="second">
                                    <li>Email</li>
                                    <li>Full name</li>
                                    <li>Phone number</li>
                                    <li>Position</li>
                                </ul>
                                <li>Client:</li>
                                    <ul className="second">
                                        <li>Name</li>
                                        <li>Contact person name</li>
                                        <li>Contact email</li>
                                        <li>Project names.</li>
                                    </ul>
                            </ul>
                        </div>
                    </div>

                    <div className="block">
                        <h3>The use and purpose of the personal data registry</h3>
                        <div className="text">
                            The service collects personal information from users so that users can be offered a
                            time-tracking service. In order for the time tracking to be carried out reliably and to meet the
                            statutory obligations related to storing work shifts, the service will collect personal information
                            from the users. The ground for processing your personal data is the data controller′s legitimate
                            interest.<br/><br/>
                            The service is an online service for companies and private individuals. The users must register
                            for the service in order to use the service.
                            The user is responsible for the use of the service that has happened using their account.
                            Personal data is used in manners allowed by the personal data act and within the boundaries
                            set by the said act.<br/><br/>
                            The registered users are in the user registry of Spark Agency FZE. The information stored in the
                            data registry is processed in accordance with the data protection legislation to deliver and 
                            improve the service, contact users and handle feedback, administer payments, for statistical
                            purposes, research, analysis, and internal business purposes, fulfill our legal and regulatory
                            obligations and for other purposes.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Slack</h3>
                        <div className="text">
                            When registering the user is identified with their email and when logging in to the service is
                            made using email as well. No password is required. The current tenant’s workspace user’s Slack
                            account authentication information is used.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Regular transfers of data and data transfers outside the European Union or the European Economic Area</h3>
                        <div className="text">
                            In all cases, personal data shall only be transferred outside the European Union (the ″EU″) or
                            the European Economic Area (the ″EEA″) on any of the following legitimate grounds:
                            <ul>
                                <li>the EU Commission has decided that the recipient country in question ensures an adequate level of protection</li>
                                <li>appropriate safeguards have been established for the transfer of personal data by using the standard data protection clauses approved by the EU Commission. User shall then have the right to obtain a copy of such standard clauses by contacting us in the manner described in this privacy policy</li>
                                <li>the user has given her or his explicit consent for the transfer of her or his personal data</li>
                                <li>another lawful basis for the transfer of personal data outside the EU or EEA exists.</li>
                            </ul>
                            Information on the current service providers and business partners in and outside the EU or EAA shall be provided on request.
                        </div>
                    </div>

                    <div className="block">
                        <h3>The principles of registry′s data protection</h3>
                        <div className="text">
                            The personal information stored in the registry is kept confidential. We take reasonable steps to
                            protect the personal information we collect from unauthorized access, use, or disclosure.
                            However, no method of internet transmission or electronic storage is completely secure, and we
                            cannot guarantee the absolute security of your personal information.
                            <br/><br/>
                            All third-party providers who may receive personal information are committed to complying with
                            the General Data Protection Regulation. Data storage requires personal identification. Personal
                            information is deleted from the registry when the user requests his or her user account to be
                            deleted as soon as this is possible.
                        </div>
                    </div>
                    
                    <div className="block">
                        <h3>Right of inspection</h3>
                        <div className="text">
                            The user can check most of the information about himself or herself directly from the application
                            of the service. The user can also contact the data protection officer of Spark Agency FZE to get
                            more information on the processing of their personal data. The user also has the right to lodge a
                            complaint with the supervisory authority concerned or with the supervisory authority of the
                            European Union if they consider that their personal data has not been processed in accordance
                            with applicable data protection legislation.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Correcting information and implementing data correction</h3>
                        <div className="text">
                            You have the right to request access to your personal data, and to request correction or deletion
                            of your personal data. If you wish to exercise this right, please contact the data protection
                            officer.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Right to be forgotten</h3>
                        <div className="text">
                            Every user has the right to claim all personal data about themselves to be removed from the
                            service and our third parties. If you wish to exercise this right, please contact the data protection
                            officer.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Right to limit processing</h3>
                        <div className="text">
                            The user is always entitled to deny access to the data for direct marketing purposes. The user
                            can exercise his right to restrict the processing of data when it is unclear whether personal data
                            should be deleted or not. If you wish to exercise this right, please contact the data protection
                            officer.
                            <br/><br/>
                            The user can use their right when:
                            <ul>
                                <li>the accuracy of personal data is under dispute</li>
                                <li>object to the removal of personal data information is no longer needed for the original purpose but can not be removed for legal reasons</li>
                                <li>the user has objected to the processing of personal data, but no decision has yet been taken.</li>
                            </ul>
                            <br/>
                            Restricting treatment means that we keep users’ personal data, but we can not use or disclose it
                            without their consent unless when used to finish statutory obligations.
                            <br/><br/>
                            Restrictions specified in the clause hereof shall not apply to the following types of information:
                            <ul>
                                <li>information that was known to Spark Agency FZE prior to its disclosure hereunder if Spark Agency FZE can prove it</li>
                                <li>information, use, or disclosure of which has been authorized by the tenant or required by law</li>
                                <li>any information that is or becomes publicly known not as a result of its unauthorized disclosure by Spark Agency FZE.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="block">
                        <h3>Right to transfer data</h3>
                        <div className="text">
                            You have the right to request the transfer of your personal data to another party in a structured,
                            commonly used, and machine-readable format. We will comply with this request unless it is
                            impractical or unreasonable to do so. If you wish to exercise this right, please contact the data
                            protection officer.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Retention period of personal data</h3>
                        <div className="text">
                            We will retain your personal data for a period of 12 months after your account becomes inactive,
                            unless you request that we delete your personal data earlier. If you do not become inactive
                            within this period, we will retain your personal data for a period of 7 years from the date of your
                            last activity on our platform. After this period, we will delete or anonymize your personal data in
                            accordance with applicable data protection laws.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Cookies</h3>
                        <div className="text">
                            The timinator.app site uses cookies to develop a user experience.
                            <br/><br/>
                            A cookie is a text file that is stored on a user’s computer while on the web. It contains
                            information and, among other things, is used to facilitate the use of the website. Cookies are
                            used to collect information about the use of the pages. The user’s identity is not reflected in the
                            cookies.
                            <br/><br/>
                            Cookies do not spread viruses or other malware because they are passive files. The site uses
                            two different types of cookies: permanent cookies and temporary cookies:
                            <ul>
                                <li>permanent cookies are text files that are sent and stored on your computer</li>
                                <li>temporary cookies are only stored on your computer for the duration of a web page. To avoid cookies, you can configure your browser settings so that cookies are not downloaded to your computer. However, this may affect the functionality of the site.</li>
                            </ul>
                        </div>
                    </div>

                    <div className="block">
                        <h3>Right to make сhanges to the policy</h3>
                        <div className="text">
                            We reserve the right to unilaterally modify this privacy policy at any time and without notice, for
                            any reason or no reason. Any changes to this privacy policy will be effective immediately upon
                            posting on the application or upon notification to you by email. Your continued use of the
                            application after any changes are made will constitute your acceptance of the revised privacy
                            policy.
                            <br/><br/>
                            It is your responsibility to check this privacy policy periodically for any changes. If you do not
                            agree to the revised privacy policy, you must stop using the application.
                            <br/><br/>
                            The relevant version of the privacy policy can be always found at: <a href="https://timinator.app/privacyPolicy">https://timinator.app/privacyPolicy</a>.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default PrivacyPolicyPage;